import { render } from "./Username.vue?vue&type=template&id=23cf5211&ts=true"
import script from "./Username.vue?vue&type=script&lang=ts"
export * from "./Username.vue?vue&type=script&lang=ts"

import exportComponent from "/root/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__